import {
    convertSearchResultEventToCalendarItemType,
    convertSearchResultMessageToMessageType,
    convertSearchResultConversationToConversationType,
    convertSearchResultTeamsMessageToTeamsMessageType,
    SearchResultSet,
    SearchResultMessage,
    SearchResultConversation,
    SearchResultEvent,
    SearchResultTeamsMessage,
    SubstrateSearchRequest,
} from 'owa-search-service';
import type Message from 'owa-service/lib/contract/Message';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import type { ConversationType } from 'owa-graph-schema';
import type { Message as TeamsMessage } from 'owa-teams-client/lib/store/schema/ServiceSchema';

export default function getSearchResultItemsFromResultSet(
    resultSet: SearchResultSet,
    entityType: string,
    searchRequest: SubstrateSearchRequest,
    provenance?: string
): (Message | CalendarItem | ConversationType | TeamsMessage)[] {
    const itemList: (Message | CalendarItem | ConversationType | TeamsMessage)[] = [];

    for (const searchResult of resultSet.Results) {
        if (entityType === 'Event' || entityType === 'Events') {
            const event = convertSearchResultEventToCalendarItemType(
                searchResult.Source as SearchResultEvent
            );
            event.InstanceKey = searchResult.ReferenceId;
            itemList.push(event);
        } else if (entityType === 'Conversation') {
            const conversation = convertSearchResultConversationToConversationType(
                searchResult.Source as SearchResultConversation,
                searchRequest
            );
            itemList.push(conversation);
        } else if (entityType === 'Message' && provenance === 'Teams') {
            const message = convertSearchResultTeamsMessageToTeamsMessageType(
                searchResult.Source as SearchResultTeamsMessage,
                searchRequest
            );

            // Teams results can sometimes come with no message content in the case of attachment/image only messages
            // We should not add these to the results list
            if (message.content !== '') {
                itemList.push(message);
            }
        } else if (
            (entityType === 'Message' || entityType === 'Messages') &&
            resultSet.Provenance !== 'Teams'
        ) {
            const message = convertSearchResultMessageToMessageType(
                searchResult.Source as SearchResultMessage,
                searchRequest
            );
            itemList.push(message);
        }
    }

    return itemList;
}
